import { type_src_supplier, type_src_purchaser } from "@common/constact"
import { setCookie } from "@common/utils"
import axios from "@common/utils/ajax"

import { getProjectId } from "@common/utils"
import { jsonParseSafe } from "@common/utils"
import { getCookie } from "@common/utils"
import { getLoginUser } from "@common/utils"

export var consumerId = sessionStorage.getItem("companyId")
var userId = sessionStorage.getItem("userId")
const currentUser = jsonParseSafe(getCookie("user2"))
let projectId = currentUser && currentUser.projectId
userId = userId || (currentUser && currentUser.id) || 123
consumerId = consumerId || (currentUser && currentUser.companyId) || 123
if (!projectId) {
  projectId = window.location.search.split("projectId=")[1] || process.env.VUE_APP_PROJECTID
}

//导入联系人
export const importSuppliercontact = params => {
  return axios
    .postMultiForm(
      `/api3/backend/v1/suppliercontact/import`,
      params
    )
    .then(res => res.data)
}

// GET /api3/activitypair/list/{purchaserId}
// 采购商-商贸配对活动列表
export const activitypairList = purchaserId => {
  return axios
    .get(`/api3/activitypair/list`)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// GET /api3/activitypair/{activityId}
// 活动详情
export const activitypairDetail = actieID => {
  return axios
    .get(`/api3/activitypair/${actieID}`)
    .then(res => res.data)
    .catch(function (error) {
    })
}
//提交 预约
// POST /api3/activitypair/invite/{activityId}/{supplierId}
// 供应商-选择采购商
export const postInvite = ({ activityId, supplierId }) => {
  return axios
    .get(`/api3/activitypair/invite/${activityId}/${supplierId}`)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// //供应商 配对活动
// export const activitypairList = (purchaserId) => {
//     return axios.get(`/api3/activitypair/list/${purchaserId}`).then(res => res.data).catch(function (error) {
//     })
// }
// //供应商 配对活动的detail
// export const activitypairDetail = (actieID) => {
//     return axios.get(`/api3/activitypair/${actieID}`).then(res => res.data).catch(function (error) {
//     })
// }
//网站统计
export function ajaxPostSiteStatic () {
  var consumerId = sessionStorage.getItem("companyId")
  var userId = sessionStorage.getItem("userId")
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/setPV/`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取匹配采购商列表
export const getSupplierPurchasers = params => {
  return axios
    .get(`/api3/purchaser/getSupplierPurchasers`, { ...params, projectId })
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取产品类型列表
export const getExhibitTypeList = params => {
  var projectId = getProjectId()
  return axios
    .get(`/api3/index/getProject/${projectId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

export const getExhibitTypeList1 = params => {
  var projectId = getProjectId()
  return axios
    .post(`/api3/org/queryProductType`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展商资料
export const getExhibitionInfo = params => {
  var userId = getLoginUser().id
  return axios
    .get(`/api3/supplier/detail/${userId}`, params)
    .then(res => res.data)
}

// 修改展商-资料
export const updateSupplier_api3 = params => {
  var userId = getLoginUser().id
  return axios
    .post(`/api3/supplier/updateSupplier/${userId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展商-我的产品
export const getExhibits = params => {
  var userId = getLoginUser().id
  return axios
    .get(`/api3/exhibit/getExhibits/${userId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展商-删除产品
export const deleteExhibit = params => {
  return axios
    .get(`/api3/exhibit/del/${params.id}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 展商-添加产品
export const addProduct = params => {
  var userId = getLoginUser().id
  return axios
    .post(`/api3/exhibit/add/${userId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 建立小号关系
export const callServiceCreate = ([purchaserId, supplierContactId]) => {
  return axios
    .post(
      `/api3/callservice/create?purchaserId=${purchaserId}&supplierContactId=${supplierContactId}`)
}

// 删除小号关系
export const callServiceDelete = params => {
  return axios
    .post(
      `/api3/callservice/delete?purchaserId=${params.purchaserId}&supplierId=${params.supplierId}`
    )
    .then(res => res.data)
    .catch(error => {
    })
}

// 统计概览(我的邀约、日程、展品、消息、活动)
export const getStatOverview = params => {
  return axios
    .get(`/api3/index/getStatOverview/${params.participant}/${params.sponsor}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取客服电话
export const getActivityInfo = params => {
  return axios
    .get(`/api3/index/getProject/${params.id}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 首页-直播视频列表
export const getLiveLists = (projectId, pageNum, pageSize) => {
  return axios.get(`/api3/live/list/${projectId}`, { pageNum, pageSize }).then(res => res.data)
}
// 首页-热门展商
export const getPurchaserSuppliers = params => {
  return axios
    .post(`/api3/supplier/getPurchaserSuppliers`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 获取栏目列表
export const getColumns = params => {
  console.log(projectId)
  return axios
    .get(`/api3/column/getColumns`, { ...params, projectId })
    .then(res => {
      console.log(res.data)
    })
    .catch(error => {
    })
}

// 获取栏目详情
export const getColumnDetail = params => {
  return axios
    .get(`/api3/column/getColumnById/${params.id}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}
// 首页-直播视频列表
export const getVideoLists = params => {
  return axios
    .get(`/api3/video/${params.projectId}`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取视频详情
export const getVideoDetail = params => {
  return axios
    .get(`/api3/video/detail/${params.id}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取我的需求
export const getDemandList = params => {
  return axios
    .get(`/api3/demand/list`, { ...params, id: userId, projectId })
    .then(res => res.data)
    .catch(error => {
    })
}

//某个人的需求
export const getDemandListOther = params => {
  return axios
    .get(`/api3/demand/list`, { ...params, projectId })
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取需求详情
export const getDemandDetail = params => {
  var userId = getLoginUser().id
  return axios
    .get(`/api3/demand/${(params && params.id) || userId}?userId=${userId}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取采购商资料
export const getPurchaserDetail = params => {
  var userId = getLoginUser().id
  return axios
    .get(`/api3/purchaser/detail/${(params && params.id) || userId}?userId=${userId}`)
    .then(res => res.data)
}

// 修改采购商资料
export const updatePurchaser_api3 = params => {
  var userId = getLoginUser().id
  return axios
    .post(`/api3/purchaser/updatePurchaser/${userId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展商列表
export const getExhibitorList = params => {
  return axios
    .post(`/api3/supplier/getPurchaserSuppliers`, { ...params, projectId })
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展商详情
export const getExhibitionDetail = params => {
  return axios
    .get(`/api3/supplier/detail/${params.id}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展品列表
export const getExhibitList = params => {
  return axios
    .get(`/api3/exhibit/getExhibits/${params.id}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取展品详情
export const getExhibitDetail = params => {
  return axios
    .get(`/api3/exhibit/detail/${params.id}`)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取热门直播
export const getHotLive = params => {
  return axios
    .get(`/api3/live/list/${projectId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 获取热门直播
export const getHotVideo = params => {
  return axios
    .get(`/api3/video/${projectId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}

// 发布修改需求
export const createOrUpdateDemand = params => {
  return axios
    .post(`/api3/demand`, { ...params, projectId, purchaserId: userId })
    .then(res => res.data)
    .catch(error => {
    })
}
export const delDemand = params => {
  return axios
    .post(`/api3/demand/del`, params)
    .then(res => res.data)
    .catch(error => {
    })
}
// 我收到的邀约
export const getMyReceiveReservation = params => {
  return axios
    .get(`/api3/schedule/getScheduleSuppliers`, {
      ...params,
      purchaserId: userId
    })
    .then(res => res.data)
    .catch(error => {
    })
}

// 我发出的邀约
export const getMySendReservation = params => {
  return axios
    .get(`/api3/schedule/getPurchaserScheduleStat/${userId}`, params)
    .then(res => res.data)
    .catch(error => {
    })
}
// 修改密码
export const getPassword = params => {
  return axios
    .post(
      `/cg/${consumerId || 11}/match/${userId || 11}/v1/updatePassword/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}

//重置密码
export const resetPassword = params => {
  if (params.src == type_src_supplier) {
    return axios
      .get(`/api3/backend/v1/supplier/${params.id}/rePw`, params)
      .then(res => res.data)
  } else {
    return axios
      .get(`/api3/backend/v1/purchaser/${params.id}/rePw`, params)
      .then(res => res.data)
  }
}

// 展商-我的邀约
export const getScheduleSuppliers = params => {
  // GET /api3/schedule/getScheduleSuppliers
  return axios
    .get(`/api3/schedule/getScheduleSuppliers`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

//  --- todo 后台

// 验证登陆是否过期
export const handleIsLogin = params => {
  return axios
    .postForm(`/cg/${consumerId}/match/${userId}/v1/validate`, params)
    .then(res => {
      var _res = res.data
      if (_res.code == 200) {
        // 已经登录
        sessionStorage.setItem("userName", _res.data.cur_user.accountName)
        sessionStorage.setItem("userId", _res.data.cur_user.userId)
        sessionStorage.setItem("companyName", _res.data.cur_org.companyName)
        sessionStorage.setItem("companyId", _res.data.cur_org.id)
        userId = _res.data.cur_user.userId
        consumerId = _res.data.cur_org.id
      } else if (_res.code == 1) {
        // token和fp为空
        if (
          location.host === "ssonew.coolgua.com" ||
          location.hostname === "localhost" ||
          location.hostname === "match.coolgua.com" ||
          location.hostname === "ywmatch.coolgua.com"
        ) {
          window.location.href = "http://sso.coolgua.com"
        } else if (location.host === "match.yiwufair.com") {
          window.location.href = "http://sso.yiwufair.com"
        } else if (location.host === "testmatch.coolgua.com") {
          window.location.href = "http://testsso.yiwufair.com"
        } else {
          window.location.href = "https://home.coolgua.net"
        }
      } else if (_res.code == 3) {
        // token值不正确,查出用户为空请重新登陆
        if (
          location.host === "ssonew.coolgua.com" ||
          location.hostname === "localhost" ||
          location.hostname === "match.coolgua.com" ||
          location.hostname === "ywmatch.coolgua.com"
        ) {
          window.location.href = "http://sso.coolgua.com"
        } else {
          window.location.href = "https://home.coolgua.net"
        }
      }
      return res.data
    })
    .catch(function (error) {
    })
}

// 登录过期返回sso
export function ssoLink () {
  if (
    location.host === "ssonew.coolgua.com" ||
    location.hostname === "localhost" ||
    location.hostname === "match.coolgua.com" ||
    location.hostname === "ywmatch.coolgua.com"
  ) {
    return "http://sso.coolgua.com"
  } else if (location.host === "match.yiwufair.com") {
    return "http://sso.yiwufair.com"
  } else if (location.host === "testmatch.coolgua.com") {
    return "http://testsso.coolgua.com"
  } else {
    return "https://home.coolgua.net"
  }
}

// 在线商贸配对活动 ---列表
export const getActivityList = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryActivityList/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 通过活动id查询撮合活动详情
export const getEditDetail = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryActivityById/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 验证活动名称是否重复
export const checkEditActivity = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/checkActivity/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改活动,修改活动状态,产品类型设为隐藏
export const sureModifyActivity = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateActivity/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建活动
export const createActivity = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/createActivity/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 复制活动
export const copyActivity = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/copyActivity/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除撮合活动
export const deleteActivity = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/deleteActivity/`, params)
    .then(res => res.data)
}
// 通过活动id查询撮合活动详情
export const getActivityDetail = params => {
  return axios
    .get(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/queryActivityById/` +
      params.projectId,
      ""
    )
    .then(res => res.data)
  // return axios
  //   .post(`/cg/${consumerId}/match/${userId}/v1/queryActivityById/`, params)
  //   .then(res => res.data)
}

// 商贸配对活动 详情
export const getActivityDetail1 = params => {
  return axios
    .get(`/api3/activitypair/${params.id}`, params)
    .then(res => res.data)
}
// 查询产品类型级联
export const searchProductType = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryCascade/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除产品类型
export const deleteProductType = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/deleteCascade/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 编辑产品类型
export const editProductType = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryCascadeByParentId/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建产品类型级联
export const createCascade = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/createCascade/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 保存编辑后的产品类型
export const saveEditProType = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateCascade/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 保存撮合活动类型
export const saveActivityProductType = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateProductType/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除隐藏字段
export const deleteHiddenField = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/deletefieldHidden/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 查询参展商列表
export const querySupplierList = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/querySupplierByList/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 国家
export const getCountry = params => {
  return axios
    .post(`/cg/area/country`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 城市
export const getCity = params => {
  return axios
    .postForm(`/cg/area/city`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 省
export const getProvince = params => {
  return axios
    .post(`/cg/area/province`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建参展商
export const createSupplier = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/createSupplier/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除参展商
export const deleteSupplier = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/deleteSupplier/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 导入文件
export const uploadFile = params => {
  return axios
    .postMultiForm(`/cg/${consumerId}/match/${userId}/v1/uploadfile`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 导出excel表格
export const downloadExcel = params => {
  return axios
    .get(`/cg/1/2/3/downloadExcel`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取云短信模板
export const getCloudSMSList = params => {
  return axios
    .post(`/backend/v1/${consumerId}/match/${userId}/v1/getCloudSMSList/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 发送短信
export const sendSmsMessages = params => {
  return axios
    .post(`/backend/v1/${consumerId}/match/${userId}/v1/sendSmsMessages/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 通过id查询参展商
export const querySupplierById = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/querySupplierById/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 查询供应商预约详情
export const querySupplierDetailById = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/querySupplierDetailById/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取采购商列表
export const getPurchaserByList = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryPurchaserByList/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除采购商
export const deletePurchaser = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/deletePurchaser/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 重置密码
export const initializationPassword = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/initializationPassword/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 查询采购商预约详情
export const queryPurchaserDetailById = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryPurchaserDetailById/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 主办方查询日程列表
export const queryScheduleByOrganizerList = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryScheduleByOrganizerList/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 查询参展商排名
export const querySupplierRankingList = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/querySupplierRankingList/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 查询采购商排名
export const queryPurchaserRankingList = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryPurchaserRankingList/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 通过Id查询日程
export const queryScheduleById = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryScheduleById/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取组织列表
export const getOrgList = params => {
  return axios
    .get(`/cg/getUserOrgs/${userId}`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 切换组织（页面）
export const changeOrg = params => {
  return axios
    .get(`/cg/saveCurOrg`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 添加登记表字段
export const setField = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/setField/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改登记表字段
export const updateField = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateField/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改登记表
export const updateRegistration = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateRegistration/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建参展商
export const updateSupplier = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateSupplier/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建采购商
export const updatePurchaser = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updatePurchaser/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建采购商
export const createPurchaser = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/createPurchaser/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 判断供应商手机号、邮箱是否重复
export const checkSupplier = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/checkSupplier/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 判断采购商手机号、邮箱是否重复
export const checkPurchaser = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/checkPurchaser/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 返回excel的表头
export const getExcelTitle = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/uploadtitles`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 导入数据保存
export const saveExcelMsg = params => {
  return axios
    .post(`/cg/cas/${consumerId}/match/${userId}/v1/conserver`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取excel信息
export const fieldmap = params => {
  return axios
    .postForm(`/cg/cas/${consumerId}/match/${userId}/v2/fieldmap`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 注销
export const logout = params => {
  return axios
    .get(`/cg/logoutv2`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取参展采购登录页活动信息
export const queryActivity = params => {
  return axios
    .post(`/v1/loginData/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 参展采购注销
export const userLogout = params => {
  var src = getLoginUser().user2src
  var contactId = getLoginUser().contactId
  if (src == 0) {
    userId = contactId
  }
  console.log('----', consumerId, userId, getLoginUser().contactId)
  return axios
    .post(`/cg/user/${projectId}/match/${userId}/v1/toQuit/${src}`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改参展采购商密码
export const updatePassword = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updatePassword/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 参展首页查询数据
export const supplierRecommendList = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/supplierRecommendList/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 采购商首页查询数据
export const purchaserRecommendList = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/purchaserRecommendList/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 参展采购搜索数据
export const searchCascadeRecommend = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/searchCascadeRecommend/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 预约统计
export const queryScheduleByIdCount = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryScheduleByIdCount/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 创建日程
export const createSchedule = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/createSchedule/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 参展日程详情
export const queryScheduleBySupplierId = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryScheduleBySupplierId/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 采购日程详情
export const queryScheduleByPurchaserId = params => {
  return axios
    .post(
      `/cg/${consumerId}/match/${userId}/v1/queryScheduleByPurchaserId/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 接受预约
export const updateSchedule = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/updateSchedule/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 改期
export const scheduleRescheduled = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/scheduleRescheduled/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 下载活动日程
export const download = params => {
  return axios
    .get(`/cg/user/1/2/3/download`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 保存小程序配置
export const saveSmallProgram = params => {
  return axios
    .post(`/api3/backend/v1/appletConfig/saveConfig`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}


export const saveSmallProgram1 = params => {
  return axios
    .post(`/api3/appletConfig/saveConfig`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取组织下的小程序的配置信息
export const getConfig = params => {
  return axios
    .get(`/api3/backend/v1/appletConfig/getConfig/${consumerId}`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

export const getConfig2 = params => {
  var companyId = sessionStorage.getItem("companyId")
  return axios
    .get(`/api3/appletConfig/getConfig/${companyId}`, companyId)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 活动详情
export const activityEditDetail = params => {
  return axios
    .get(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/queryActivityById/` +
      params.projectId,
      ""
    )
    .then(res => res.data)
}

// 创建活动
export const createActivityNew = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/createActivity/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改活动,修改活动状态,产品类型设为隐藏
export const editModifyActivity = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/updateActivity/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 复制活动
export const copyActivityNew = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/copyActivity/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取参展商/采购商字段/展品字段
export const getFieldRegistration = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/queryRegistration/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 导入文件
export const uploadFileNew = params => {
  return axios
    .postMultiForm(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/uploadfile`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 返回excel的表头
export const getExcelTitleNew = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/uploadtitles`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取excel信息
export const fieldmapNew = params => {
  return axios
    .postForm(
      `/api3/backend/v1/cas/${consumerId}/match/${userId}/v2/fieldmap`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 导入数据保存
export const saveExcelMsgNew = params => {
  return axios
    .post(
      `/api3/backend/v1/cas/${consumerId}/match/${userId}/v1/conserver`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 参展商联系人
export const getContactConfig = params => {
  return axios
    .get(`/api3/backend/v1/suppliercontact/getPages`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 新增参展商联系人
export const addSuppliercontact = params => {
  return axios
    .post(`/api3/backend/v1/suppliercontact/addOne`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除参展商联系人
export const deleteContactConfig = params => {
  return axios
    .get(`/api3/backend/v1/suppliercontact/delOne/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取参展商展品
export const getSupplierExhibits = params => {
  return axios
    .get(`/api3/backend/v1/exhibit/getSupplierExhibits`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 新增参展商展品
export const addSupplierExhibit = params => {
  return axios
    .post(`/api3/backend/v1/exhibit/add/` + params.id, params.data)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 删除参展商展品
export const deleteSupplierExhibit = params => {
  return axios
    .get(`/api3/backend/v1/exhibit/del/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 展品管理列表
export const getManageExhibits = params => {
  return axios
    .get(`/api3/backend/v1/exhibit/getManageExhibits`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取其他管理的栏目列表
export const getOtherConfig = params => {
  return axios
    .get(`/api3/column/getColumns`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取其他管理的栏目详情
export const getColumnById = params => {
  return axios
    .get(`/api3/column/getColumnById/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改登记表
export const updateRegistrationNew = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/updateRegistration/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 添加登记表字段
export const setFieldNew = params => {
  return axios
    .post(`/api3/backend/v1/${consumerId}/match/${userId}/v1/setField/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改登记表字段
export const updateFieldNew = params => {
  return axios
    .post(
      `/api3/backend/v1/${consumerId}/match/${userId}/v1/updateField/`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取其他管理的栏目详情--保存栏目
export const saveOrUpdateColumn = params => {
  return axios
    .post(`/api3/column/saveOrUpdateColumn`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取其他管理的栏目详情--保存友情链接
export const columnDetail = params => {
  return axios
    .post(`/api3/column/columnDetail`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取其他管理的栏目详情--获取友情链接详情
export const getColumnDetailById = params => {
  return axios
    .get(`/api3/column/getColumnDetailById/` + params.id, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 参展商展品排序
export const sortExhibits = params => {
  return axios
    .post(`/api3/exhibit/sortExhibits`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 需求管理--下载导入模板
export const downloadDemandTemplate = params => {
  return axios
    .get(`/api3/backend/v2/demand/downloadTemplate`, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 需求管理--导入模板
export const demandImportFile = params => {
  return axios
    .postMultiForm(
      `/api3/backend/v2/demand/` + params.projectId + `/importFile`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动管理--会议管理列表
export const meetingList = params => {
  return axios
    .get(`/api3/backend/v2/meeting/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播管理--直播管理列表
export const getLiveList = params => {
  return axios
    .get(`/api3/backend/v2/live/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播管理--直播权限管理列表
export const getLiveauthList = params => {
  return axios
    .get(`/api3/backend/v2/liveauth/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 轮播图管理--轮播图列表
export const getRotationList = params => {
  return axios
    .get(`/api3/backend/v2/rotation/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 图片上传POST
export const uploadThumbnail = params => {
  return axios
    .postMultiForm(
      `/cg/${consumerId}/match/${userId}/v1/uploadThumbnail`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 轮播图 ---新增
export const addRotation = params => {
  return axios
    .get(`/api3/backend/v2/rotation/addRotation`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 轮播图 ---编辑
export const editRotation = params => {
  return axios
    .get(`/api3/backend/v2/rotation/updateRotation`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---列表
export const getActivityList_api3 = params => {
  return axios
    .get(`/api3/backend/v2/activity/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---新增
export const addActivity = params => {
  return axios
    .post(`/api3/backend/v2/activity/addEntity`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---查询
export const getActivityDetail_api3 = params => {
  return axios
    .get(`/api3/backend/v2/activity/getEntity`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---编辑
export const editActivity = params => {
  return axios
    .post(`/api3/backend/v2/activity/updateEntity`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动--需求--下载导入模板
export const downloadActivityDemandTemplate = params => {
  return axios
    .get(`/api3/backend/v2/activitydemand/downloadTemplate`, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---参展商列表
export const getActivitySupplier = params => {
  return axios
    .get(`/api3/backend/v2/activitysupplier/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---参展商列表--移出
export const deleteActivitySupplier = params => {
  return axios
    .post(`/api3/backend/v2/activitysupplier/delEntity?id=` + params.id, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---参展商列表--批量移出
export const delActivitySupplier = params => {
  return axios
    .post(`/api3/backend/v2/activitysupplier/delEntityList`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---添加参展商列表
export const getAddSupplierPage = params => {
  return axios
    .get(`/api3/backend/v2/activitysupplier/getAddSupplierPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---添加参展商列表--添加
export const addEntitySupplier = params => {
  return axios
    .post(
      `/api3/backend/v2/activitysupplier/addEntity?activityId=` +
      params.activityId +
      `&supplierId=` +
      params.supplierId,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---参展商列表--批量添加
export const addActivitySupplier = params => {
  return axios
    .post(
      `/api3/backend/v2/activitysupplier/addEntityList?activityId=` +
      params.activityId +
      `&supplierIds=` +
      params.supplierIds,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求列表
export const getActivityDemand = params => {
  return axios
    .get(`/api3/backend/v2/activitydemand/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---添加需求列表
export const getAddDemandSupplierPage = params => {
  return axios
    .get(`/api3/backend/v2/activitydemand/getAddDemandPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---添加需求列表--加入活动
export const addEntityDemand = params => {
  return axios
    .post(
      `/api3/backend/v2/activitydemand/addEntity?activityId=` +
      params.activityId +
      `&demandId=` +
      params.demandId,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---添加需求列表--批量加入活动
export const addEntityDemandList = params => {
  return axios
    .post(
      `/api3/backend/v2/activitydemand/addEntityList?activityId=` +
      params.activityId +
      `&demandIds=` +
      params.demandIds,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求列表--移出活动
export const delActivityDemand = params => {
  return axios
    .post(`/api3/backend/v2/activitydemand/delEntity?id=` + params.id, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约列表
export const getAppointment = params => {
  return axios
    .get(`/api3/backend/v2/appointment/getPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约详情
export const getAppointmentPage = params => {
  return axios
    .get(`/api3/backend/v2/appointment/getAppointmentPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约管理--预约展商列表
export const addSupplierAppointment = params => {
  return axios
    .get(`/api3/backend/v2/appointment/getAppointmentSupplierPage`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约管理--添加预约
export const addAppointmentDemand = params => {
  return axios
    .post(`/api3/backend/v2/appointment/addAppointment`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约管理--批量添加
export const addAppointmentDemandList = params => {
  return axios
    .post(`/api3/backend/v2/appointment/addAppointmentList`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---预约管理--取消预约
export const cancelAppointment = params => {
  return axios
    .post(
      `/api3/backend/v2/appointment/cancelAppointment?id=` + params.id,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求管理--需求列表
export const demandList = params => {
  return axios
    .get(`/api3/demand/list`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求管理--导入模板
export const activityDemandImportFile = params => {
  return axios
    .postMultiForm(
      `/api3/backend/v2/activitydemand/` +
      params.projectId +
      `/` +
      params.activityId +
      `/importFile`,
      params
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求管理--需求详情
export const demandDetail = params => {
  return axios
    .get(`/api3/demand/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---需求管理--审核
export const examineDemandDetail = params => {
  return axios
    .post(`/api3/demand`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---会议管理--进入会议
export const admininterMeeting = params => {
  return axios
    .get(
      `api3/meeting/admininter/e51307b39dac905fdcf04f619981/` + params.id,
      ""
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---会议管理--获取会议的secretKey
export const secretKeyMeeting = params => {
  return axios
    .get(`/api3/meeting/secretKey/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 在线商贸配对活动 ---会议管理--结束会议
export const dissolveMeeting = params => {
  return axios
    .post(
      `/api3/trtcorim/dissolveRoom/` + params.secretKey + `/` + params.id,
      params.body
    )
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 通过id查询采购商
export const queryPurchaserById = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryPurchaserById/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播管理--停止直播
export const stopLive = params => {
  return axios
    .get(`/api3/live/stopLive/` + params.id, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播权限管理--停止
export const liveauthUpdate = params => {
  return axios
    .post(`/api3/backend/v2/liveauth/updateStatus/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播权限管理--添加
// POST /backend/v2/liveauth/addEntity
export const liveauthAdd = params => {
  return axios
    .post(`/api3/backend/v2/liveauth/addEntity`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 直播权限管理--毗连添加
// POST /backend/v2/liveauth/POST /backend/v2/liveauth/addBatchEntity
export const liveauthAddBatch = params => {
  return axios
    .post(`/api3/backend/v2/liveauth/addBatchEntity`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 直播权限管理--批量停止
export const updateBatchLive = params => {
  return axios
    .post(`/api3/backend/v2/liveauth/updateBatchStatus/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 数据统计---数据概览
export const getStatistics = params => {
  return axios
    .get(`/api3/backend/v1/statistics/` + params.projectId, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 数据统计---预约会议数据
export const getMeetingStatistics = params => {
  return axios
    .get(`/api3/backend/v1/statistics/meeting/` + params.projectId, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 数据统计---直播数据
export const getLiveStatistics = params => {
  return axios
    .get(`/api3/backend/v1/statistics/live/` + params.projectId, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 数据统计---及时通讯数据
export const getInstantStatistics = params => {
  return axios
    .get(`/api3/backend/v1/statistics/instant/` + params.projectId, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取参展商/采购商字段
export const getQueryRegistration = params => {
  return axios
    .post(`/cg/${consumerId}/match/${userId}/v1/queryRegistration/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 其他管理---删除栏目
export const deleteColumn = params => {
  return axios
    .get(`/api3/column/delColumn/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 轮播图---删除轮播图
export const delRotation = params => {
  return axios
    .get(`/api3/index/delRotation/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 撮合活动管理---删除活动
export const deleteActivity_api3 = params => {
  return axios
    .get(`/api3/activity/del/` + params.id, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 其他管理--小瓜报名---活动列表
export const getEventList = params => {
  return axios
    .get(`/api3/column/getEventList/${consumerId}`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 其他管理--cms栏目---栏目列表
export const getExternaList = params => {
  return axios
    .get(`/api3/category/externallist?typeId=4&orgId=${consumerId}`, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 广告管理--推荐展商---列表
export const recommendSupplier = params => {
  return axios
    .get(`/api3/advertising/recommendSupplier/list`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展品---列表
export const recommendExhibits = params => {
  return axios
    .get(`/api3/advertising/recommendExhibit/list`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展商---添加/编辑
export const addRecommendExhibitor = params => {
  return axios
    .post(`/api3/advertising/recommendSupplier`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展商---删除
export const delRecommendSupplier = params => {
  return axios
    .post(`/api3/advertising/del/recommendSupplier`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展品---删除
export const delRecommendExhibit = params => {
  return axios
    .post(`/api3/advertising/del/recommendExhibit`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展品---添加/编辑
export const addRecommendExhibit = params => {
  return axios
    .post(`/api3/advertising/recommendExhibit `, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展商---排序
export const sortRecommendSupplier = params => {
  return axios
    .post(`/api3/advertising/recommendSupplier/sort`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 广告管理--推荐展品---排序
export const sortRecommendExhibit = params => {
  return axios
    .post(`/api3/advertising/recommendExhibit/sort`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

// 轮播图
export const getSlide = params => {
  const { type, clientType, projectId } = params
  return axios
    .get(`/api3/index/getRotations/${type}/${clientType}/${projectId}`)
    .then(res => res.data)
};
// 小程序查看所有vr参展商 
export const vrSelectSuppliers = params => {
  return axios
    .get(`/api3/supplier/vrSelectSuppliers`, { ...params, projectId })
    .then(res => res.data)
};
// 小程序vr参展商详情 
export const vrList = params => {
  return axios
    .get(`/api3/supplier/detail/${params.supplierId}`)
    .then(res => res.data)
};

//友情链接
export const getFriendLink = params => {
  return axios
    .get(`/api3/column/getColumns`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
//首页活动详情
// export const queryActivity = params => {
//   return axios.post(`/v1/loginData/`, params).then(res => res.data).catch(function (error) {
//   })
// }
export const queryActivity_api3 = params => {
  return axios
    .get(`/api3/index/getProject/${params.projectId}`, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 数据统计---预约会议数据
export const getMeetingStatistics111 = params => {
  return axios
    .get(`/api3/backend/v1/statistics/` + params.projectId, "")
    .then(res => res.data)
    .catch(function (error) {
    })
}

//cms文章列表
export const getArticleList = params => {
  return axios
    .get(`/api3/article/list`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
//cms文章详情
export const getArticleDetail = params => {
  return axios
    .get(`/api3/article/detail/` + params.id, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

export const getLiveGetPushUrl = params => {
  // var paramsUrl=params2url({id:params.id})
  return axios
    .post(`/api3/live/getPushUrl`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

//获取直播的播放路径 GET  /api3/live/getPullUrl/{id}/{type}/{userId
export const getLiveUrl = ({ id, type, userId }) => {
  return axios
    .get(`/api3/live/getPullUrl/${id}/${type}/${userId}`)
    .then(res => res.data)
    .catch(function (error) {
    })
}

//胡哦去直播列表 GET /api3/live/mylives/{supplierId}
export const getLiveLists_me = (options) => {
  return axios
    .get(`/api3/live/mylives/${options.supplierId}`, {
      ...options,
      pageSize: options.pageSize || 1,
      pageNum: options.pageNum || 10
    })
    .then(res => res.data)
}

// 验证参展采购登录
export const login = params => {
  return axios.post(`/v1/login/`, params).then(res => {
    var _res = res.data
    if (_res.code == 0) {
      sessionStorage.setItem("companyId", _res.user2.projectId)
      sessionStorage.setItem("userComName", _res.user2.contact)
      sessionStorage.setItem("userComNameEn", _res.user2.contactEn)
      sessionStorage.setItem("userId", _res.user2.id)
      sessionStorage.setItem("contactId", _res.user2.contactId)
      sessionStorage.setItem("updateTime", _res.user2.updateTime)
      setCookie("user2", JSON.stringify(_res.user2))
      userId = _res.user2.id
      consumerId = _res.user2.projectId
    }
    return res.data
  })
}
export const ajaxPurchaserlogin = params => {
  return axios.post(`/v1/mobileLogin/`, params).then(res => {
    var _res = res.data
    if (_res.code == 0) {
      sessionStorage.setItem("companyId", _res.user2.projectId)
      sessionStorage.setItem("userComName", _res.user2.contact)
      sessionStorage.setItem("userComNameEn", _res.user2.contactEn)
      sessionStorage.setItem("userId", _res.user2.id)
      sessionStorage.setItem("updateTime", _res.user2.updateTime)
      sessionStorage.setItem("contactId", _res.user2.contactId)
      setCookie("user2", JSON.stringify(_res.user2))
      userId = _res.user2.id
      consumerId = _res.user2.projectId
    }
    return res.data
  })
}
// 获取参展采购登录页验证图片
export const getGifCode = params => {
  return axios
    .post(`/v1/gitGif/`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取采购商手机验证码
export const getMobileCode = params => {
  return axios
    .get(`/v1/getMobileCode`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 获取采购商邮箱验证码
export const getMailCode = params => {
  return axios
    .get(`/v1/getMailCode`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}
// 修改密码验证码
export const sendCode = params => {
  return axios
    .get(`/cg/v1/changeinfo/sendCode`, params)
    .then(res => res.data)
    .catch(function (error) {
    })
}

//系统消息
export const ajaxSystemMessageList = params => {
  return axios
    .get(`/api3/message/newmessage/list/${params.userId}`, params)
    .then(res => res.data)
}

//点赞收藏
export function addCollect (params) {
  return axios
    .post(`/api3/livecollect`, params)
    .then(res => res.data)
}

//取消点赞收藏
export function delCollect (params) {
  return axios
    .get(`/api3/livecollect/del/${params.id}`)
    .then(res => res.data)
}

//点赞收藏列表
export function collectList (params) {
  return axios
    .get(`/api3/livecollect/list`, params)
    .then(res => res.data)
}


//查询服务商列表
export function getVrProviderInfo () {
  return axios
    .get(`/api3/backend/v1/vr/vrProviderInfo/${consumerId}`)
    .then(res => res.data)
}

//查询服务商列表
export function updateVrProviderInfo (params) {
  return axios
    .post(`/api3/backend/v1/vr/vrProviderEdit`, params)
    .then(res => res.data)
}
//参展商更改VR服务商
export function updateVrProvider (supplierId, providerId) {
  return axios
    .post(`/api3/supplier/${supplierId}/${providerId}/updateSupplierProvider/`)
    .then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/common/api/index.js